export default "__VITE_ASSET__DgG_Ibv$__"